module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageNotification.svg?9c4f9b28";